import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import AddCoupon from "../../images/addCoupon.png"

const Coupon = () => {
  const CouponDocs = {
    title: "Coupons",
    description: "Coupons are valuable tools for customer retention. Note that adding coupons is irreversible, and incorrect configurations can result in financial loss for the company.",
    sections: [
      {
        title: "Overview",
        content: "This section allows you to add and manage coupons for various promotions and rewards.",
      },
      {
        title: "Add Coupons",
        content: "Learn how to create and configure new coupons to offer rewards and incentives to customers.",
        image: AddCoupon,
        imageAlt: "Add coupon to Products",
        imageCaption: "Figure 1: Detailed view of the Add Product Coupon modal",
        subsections: [
          {
            title: "Steps to Add a Coupon",
            content: "Follow these steps to add a new coupon. Ensure each field is filled accurately to prevent errors.",
            steps: [
              "Name: Enter a descriptive name for the coupon (e.g., 'New Customer Discount'). The name should indicate the purpose of the coupon.",
              "Code: Create a unique code for the coupon. This code is what customers will enter to redeem the discount or reward.",
              "Coupon Type: Select the type of coupon from the following options:\n - **Cash Rewards**: Provides a discount or cashback on purchases.\n - **Free Delivery**: Covers delivery costs, allowing customers to receive free shipping.\n - **Combo**: Combines both a cash reward and free delivery benefits.",
              "Onboarding Coupons: Specify if this coupon is intended for new customers. Onboarding coupons help incentivize first-time purchases.",
              "Duration: Set a start and end date for the coupon. Defining a time limit helps control the promotion’s duration and manage its effectiveness.",
              "Issue All: Use this option to distribute the coupon to all eligible customers. This is ideal for general promotions.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...CouponDocs} />;
};

export default Coupon;
